import React, { useState } from "react"

import OutfitterLodgingsEmpty from "~components/pages/outfitter/lodgings/outfitter-lodgings-empty"
import type {
    OutfitterLodgingFieldsFragment,
    PublicLodgingFieldsFragment,
} from "~graphql/generated/graphql"
import LodgeItemModal from "~components/pages/outfitter/lodgings/lodge-item-modal"
import LodgingsCollection from "~components/shared/collections/lodgings-collection"
import COPY from "~config/copy-constants"
import { TYPES } from "~components/shared/collections/generic-collection"

interface Props {
    readonly testId?: string
    readonly lodgings: PublicLodgingFieldsFragment[]
    readonly isLoading?: boolean
}

export default function LodgingsCollectionWithModal({
    testId,
    lodgings,
    isLoading,
}: Props) {
    const [selectedLodging, setSelectedLodging] =
        useState<OutfitterLodgingFieldsFragment>()

    const onOpen = (lodging: OutfitterLodgingFieldsFragment) => {
        setSelectedLodging(lodging)
    }

    const onClose = () => {
        setSelectedLodging(undefined)
    }

    return (
        <div data-testid={testId}>
            {lodgings.length > 0 ? (
                <LodgingsCollection
                    label={COPY.LODGING}
                    lodgings={lodgings}
                    handleClick={onOpen}
                    type={TYPES.SLIDER}
                    isLoading={isLoading}
                />
            ) : (
                <OutfitterLodgingsEmpty />
            )}
            {selectedLodging && (
                <LodgeItemModal
                    isOpen={!!selectedLodging}
                    onClose={onClose}
                    lodging={selectedLodging}
                />
            )}
        </div>
    )
}
